<script>
import Layout from "../../layouts/main";
import PageHeader from "../../components/page-header";
import moment from "moment";
/**
 * Starter component
 */
export default {
    components: { Layout, PageHeader },
    data() {
        return {
            title: "Historial de acciones",
            items: [
                {
                text: "Usuarios",
                href: "/"
                },
                {
                text: "Historial",
                active: true
                }
            ],
            acciones:[],
            currentPage: 1,
            perPage: 10,
            pageOptions: [10, 25, 50, 100],
            filtro: '',
            historial:[],
            laborantes:[]
        };
    },
    computed:{
        rows() {
            return this.historial.length;
        },
        filteredData() {
            // Filtramos los datos en base al campo 'filtro' 
            return this.historial.filter((item) => {
                // Aquí puedes personalizar los campos a buscar
                return (
                    //item.rut.toLowerCase().includes(this.filtro.toLowerCase()) ||
                    item//.name.toLowerCase().includes(this.filtro.toLowerCase())
                );
            });
        },
        paginatedData() {
            const start = (this.currentPage - 1) * this.perPage;
            const end = start + this.perPage;
            return this.filteredData.slice(start, end)
        },
        totalPages() {
            return Math.ceil(this.filteredData.length / this.perPage);
        },
    },
    methods:{
        formatFecha(fechahora){
            var orden = moment(fechahora).format('DD-MM-YYYY');
            return orden
        },
        formatHora(fechahora){
            var orden = moment(fechahora).format('HH:mm:ss');
            return orden
        },
        get_accion(item){
            let acc = this.acciones.find(us=>us.id==item)
            return acc.nombre
        },
        detalle(item){
            if (item.accion_id==1) {
                return 'Se a iniciado sesión en la plataforma'
            }else if(item.accion_id==2){
                return 'Se ha editado el colegio'
            }else if(item.accion_id==3){
                return 'Se ha creado el evento'
            }else if(item.accion_id==4){
                return 'Se ha editado el evento'
            }else if(item.accion_id==5){
                let nuevo = JSON.parse(item.nuevo);
                let laborante = this.laborantes.find(us=>us.id==nuevo.laborante_id)
                return 'Se agrego a '+laborante.name+' como laborante entre las '+nuevo.hora_inicio+' y las '+nuevo.hora_fin+' para el dia '+nuevo.fecha
            }else if(item.accion_id==6){
                let nuevo = JSON.parse(item.nuevo);
                let laborante = this.laborantes.find(us=>us.id==nuevo.laborante_id)
                return 'Se agrego a '+laborante.name+' como apoyo a oficina entre las '+nuevo.hora_inicio+' y las '+nuevo.hora_fin+' para el dia '+nuevo.fecha
            }else if(item.accion_id==7){
                let nuevo = JSON.parse(item.nuevo);
                let laborante = this.laborantes.find(us=>us.id==nuevo.laborante_id)
                return 'Se agrego a '+laborante.name+' como digitalizador de '+nuevo.cantidad_encuestas+'encuestas para el dia '+nuevo.fecha
            }else if(item.accion_id==8){
                let nuevo = JSON.parse(item.nuevo);
                let laborante = this.laborantes.find(us=>us.id==nuevo.laborante_id)
                return 'Se agrego a '+laborante.name+' para salida de actividades entre las '+nuevo.hora_inicio+' y las '+nuevo.hora_fin+' para el dia '+nuevo.fecha
            }else if(item.accion_id==9){
                return 'Se agregó un gasto asociado'
            }else if(item.accion_id==10){
                return 'Se editó un gasto asociado'
            }else if(item.accion_id==11){
                return 'Se evaluó un laborante'
            }else if(item.accion_id==12){
                return 'Se editó la evaluacion de un laborante'
            }
        }
    },
    mounted(){
        if (localStorage.getItem("user_log")) {
            const usuario = localStorage.getItem("user_log");
            localStorage.removeItem("user_log");
            axios.get('/api/get_historial/'+usuario).then(res=>{
                this.historial=res.data.historial;
            });
        }else{
            window.location.href = "/web/invitado/listado";
        }
    },
    created(){
        axios.get('/api/get_acciones').then(res=>{
            this.acciones=res.data.acciones;
        });
        axios.get('/api/get_laborantes').then(res=>{
            this.laborantes=res.data.usuarios;
        });
    }
};
</script>
<template>
    <Layout>
        <PageHeader :title="title" :items="items" />
        <div class="row">
            <div class="col-12">
                <div class="card">
                    <!-- Header UGM -->
                    <div class="card-header py-3 d-flex align-items-center"
                        style="background: linear-gradient(135deg, #252C5F 0%, #61B7E4 100%); border-radius: 4px 4px 0 0;">
                        <i class="bx bx-time-five font-size-24 text-white mr-2"></i>
                        <div>
                            <h5 class="text-white mb-0 font-weight-bold">Historial de Acciones</h5>
                            <small class="text-white" style="opacity:.8;">Revisa el historial de acciones realizadas</small>
                        </div>
                    </div>
                    <div class="card-body">
                        <div class="row">
                            <div class="col-sm-12 col-md-6">
                                <div id="tickets-table_length" class="dataTables_length">
                                    <label class="d-inline-flex align-items-center">
                                        Mostrar&nbsp;
                                        <b-form-select v-model="perPage" size="sm" :options="pageOptions"></b-form-select>&nbsp;recibos
                                    </label>
                                </div>
                            </div>
                            <div class="col-sm-12 col-md-6">
                                <div id="tickets-table_filter" class="dataTables_filter text-md-right">
                                    <label class="d-inline-flex align-items-center">
                                        Buscar:
                                        <b-form-input
                                        v-model="filtro"
                                        type="search"
                                        placeholder="Buscar..."
                                        class="form-control form-control-sm ml-2"
                                        ></b-form-input>
                                    </label>
                                </div>
                            </div>
                        </div>
                        <div class="table-responsive mb-0 mt-3">
                            <table class="table table-hover">
                                <thead>
                                    <tr>
                                        <th style="width: 5%;">Nº</th>
                                        <th style="width: 20%;">Acción realizada</th>
                                        <th style="width: 10%;">Fecha</th>
                                        <th style="width: 10%;">Hora</th>
                                        <th style="width: 50%;">Detalle</th>
                                    </tr>
                                </thead>
                                <tbody>
                                    <tr v-for="(item, index) in paginatedData" :key="index">
                                        <td>{{ index+1 }}</td>
                                        <td>{{ get_accion(item.accion_id) }}</td>
                                        <td>{{ formatFecha(item.fecha) }}</td>
                                        <td>{{ formatHora(item.fecha) }}</td>
                                        <td>{{ detalle(item) }}</td>
                                    </tr>
                                </tbody>
                            </table>
                        </div>
                        <div class="row">
                            <div class="col">
                                <div class="dataTables_paginate paging_simple_numbers float-right">
                                    <ul class="pagination pagination-rounded mb-0">
                                        <!-- pagination -->
                                        <b-pagination v-model="currentPage" :total-rows="rows" :per-page="perPage"></b-pagination>
                                    </ul>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </Layout>
</template>